import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';

import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ActiveMenuModel, MenuModel} from '../../../../models/menu.model';
import {MemberModel} from '../../../../models/user.model';
import {
    DEFAULT_SETTINGS_DIALOG,
    TWidgetKeys,
    WIDGET_COMPONENTS,
    WIDGET_TYPES,
    WidgetModel
} from '../../model/widget.model';
import {CrmService} from '../../../../services/api/crm.service';
import {ModalService} from '../../../../services/modal/modal.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {TaskServiceService} from '../../../../services/task-service.service';
import {WidgetsService} from '../../services/widgets.service';
import {CdkDragEnd, CdkDragStart} from '@angular/cdk/drag-drop';
import {MatDialog} from '@angular/material/dialog';
import {
    AppWidgetRootSettingsComponent
} from '../../components/widget-root/widget-settings/widget-root-settings.component';
import {Subscription} from 'rxjs';
import {
    AppWidgetCreateNewSettingsComponent
} from '../../components/widget-create-new-settings/widget-create-new-settings.component';
import {TFormState} from '../../../../models/forms.model';

@Component({
    selector: 'app-widgets-board',
    templateUrl: './widgets-board.component.html',
    styleUrl: './widgets-board.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppWidgetsBoardComponent implements OnInit {
    public formState: TFormState = 'Default'
    public noWidgets: boolean = false
    @Input() editMode = false;
    @ViewChild('gridLayout') gridLayout!: ElementRef;
    public menu: ActiveMenuModel[] = [];
    public copyExistsMenu!: MenuModel[];
    public profileData!: MemberModel;
    public widgets: WidgetModel[] = [];
    public cloneWidgets: WidgetModel[] = [];
    public modifiedWidgets: { [key: number]: WidgetModel } = {};
    public gridColumns: number = 10;
    public gridRows: number = 3;
    public gridRowsMax: number = 15;
    public gridCellWidth:number = 200
    public widgetsType: { [key: string]: string } = WIDGET_TYPES;
    public widgetsComponents = WIDGET_COMPONENTS;
    public editingWidget: { open: boolean, content: any }[] = [];
    public isModifiedWidgets: boolean = false;
    private subscriptions = new Subscription()
    private dragZindexMax = 1999
    public isSettingsLoading: boolean = false;

    constructor(
        private widgetsService: WidgetsService,
        private alertService: AlertService,
        private changeDetectorRef: ChangeDetectorRef,
        protected router: Router,
        protected translate: TranslateService,
        protected modalService: ModalService,
        protected taskService: TaskServiceService,
        protected crmService: CrmService,
        private dialog: MatDialog
    ) {
    }

    get gridTemplateColumns(): string {
        const maxX = Math.max(...this.widgets.map(i => i.screen_x + i.width), 1);
        return `repeat(${maxX > this.gridColumns ? maxX : this.gridColumns}, ${this.gridCellWidth}px)`;
    }

    get gridTemplateRows(): string {
        const maxY = Math.max(...this.widgets.map(i => i.screen_y + i.height), 1);
        return `repeat(${maxY > this.gridRows ? maxY : this.gridRows}, ${this.gridCellWidth}px)`;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }

    ngOnInit(): void {
        this.initializeWidgets();
        this.setSubscriptions()
    }

    setSubscriptions() {
        this.subscriptions.add(this.widgetsService.subWidgetNewCreate.asObservable().subscribe(() => {
                let newWidget: WidgetModel = {
                    title: 'Новый виджет',
                    height: 1,
                    width: 1,
                    screen_x: 1,
                    screen_y: 1,
                    widget_key: null,
                    owner_guid: '',
                    description: '',
                    options_dict: [],
                    id: 0,
                    content: {}

                };
                let dialogRef = this.dialog.open(AppWidgetCreateNewSettingsComponent, {
                    height: '30%',
                    width: '50vw',
                    minHeight: '200px',
                    minWidth: '50vw',
                    maxWidth: '100%'
                })
                dialogRef.componentInstance.widget = newWidget
            })
        )
        this.subscriptions.add(
            this.widgetsService.subWidgetSettingsChanged.asObservable().subscribe(widget => {
                let index = this.widgets.findIndex(el => el.id === widget.id)
                this.widgets[index] = {...widget, style: this.widgets[index].style}
                this.changeDetectorRef.detectChanges()
            })
        )
        this.subscriptions.add(this.widgetsService.subWidgetNewHasCreated.asObservable().subscribe(newWidget => {
            newWidget.new_widget = true;
            newWidget.style = {
                'grid-column': `1 / span 1`,
                'grid-row': `1 / span 1`
            }
            this.dragZindexMax = this.dragZindexMax + 1
            newWidget.zIndex = (this.dragZindexMax + 1).toString()
            let full = [...this.widgets]
            this.widgets = [newWidget, ...full]
            this.changeDetectorRef.detectChanges()
        }))
    }

    initializeWidgets() {
        this.widgetsService.getWidgets().subscribe({
            next: res => {
                res.widgets.length===0 ? this.noWidgets = true : null
                this.changeDetectorRef.detectChanges()
                this.widgets = res.widgets.map((widget: WidgetModel) => {
                    widget.style = {
                        'grid-column': `${Math.min(widget.screen_x, this.gridCellWidth)} / span ${Math.min(widget.width, this.gridCellWidth)}`,
                        'grid-row': `${Math.min(widget.screen_y, this.gridRowsMax)} / span ${Math.min(widget.height, this.gridRowsMax)}`
                    };
                    return widget;
                });
                let iteration = 0;
                this.widgets.forEach((widget: WidgetModel) => {
                    if (widget.widget_key === 'WIDGET_EFT_CONTRACT_FILTER' && widget.title==='Контракты') {
                      widget.content = {data:''}
                      widget.widget_key = 'WIDGET_EFT_CONTRACT_TABLE'
                      iteration += 1;
                      this.changeDetectorRef.detectChanges();
                      if (iteration === this.widgets.length) {
                          this.cloneWidgets = structuredClone(this.widgets);
                      }
                    } else {
                      this.widgetsService.getWidgetById(widget.id).subscribe({
                          next: resWidget => {
                              widget.content = resWidget.widget.content;
                              iteration += 1;

                              this.changeDetectorRef.detectChanges();
                              if (iteration === this.widgets.length) {
                                  this.cloneWidgets = structuredClone(this.widgets);
                              }
                          }, error: err => {
                              this.alertService.setAlert('Ошибка загрузки данных виджета: ' + widget.title + ' id ' + widget.id + ' тип ' + widget.widget_key, 'blue', 6);
                          }
                      });
                    }
                  
                });

                this.updateGridDimensions();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    updateGridDimensions() {
        let maxCol = 0;
        let maxRow = 0;
        this.widgets.forEach(block => {
            maxCol = Math.max(maxCol, block.screen_x + block.width - 1);
            maxRow = Math.max(maxRow, block.screen_y + block.height - 1);
        });

        this.gridColumns = maxCol > this.gridColumns ? maxCol : this.gridColumns;
        this.gridRows = maxRow >= this.gridRows ? (maxRow + 1) : this.gridRows;
    }

    onDragEnd(event: CdkDragEnd, item: any) {
        const dragRef = event.source;
        const pos = dragRef.getFreeDragPosition();

        const snappedX = Math.round(pos.x / this.gridCellWidth);
        const snappedY = Math.round(pos.y / this.gridCellWidth);


        item.screen_x += snappedX;
        item.screen_y += snappedY;

        if (item.screen_y <= 0) {
            item.screen_y = 1;
        }
        if (item.screen_x <= 0) {
            item.screen_x = 1;
        }

        item.style = {
            'grid-column': `${item.screen_x} / span ${item.width}`,
            'grid-row': `${item.screen_y} / span ${item.height}`
        };

        dragRef.reset();
        this.checkUpdates(item);
    }

    onDragStarted(event: CdkDragStart) {
        this.dragZindexMax = this.dragZindexMax + 1;
        (event.source.element.nativeElement as HTMLElement).style.zIndex = this.dragZindexMax.toString();
    }

    trackById(index: number, item: WidgetModel): number {
        return item.id;
    }

    onResizeMouseDown(event: MouseEvent, item: any) {
        event.preventDefault();
        const startX = event.clientX;
        const startY = event.clientY;
        const startWidth = item.width;
        const startHeight = item.height;

        const onMouseMove = (moveEvent: MouseEvent) => {
            const dx = moveEvent.clientX - startX;
            const dy = moveEvent.clientY - startY;

            const newWidth = Math.max(1, Math.round((startWidth * this.gridCellWidth + dx) / this.gridCellWidth));
            const newHeight = Math.max(1, Math.round((startHeight * this.gridCellWidth + dy) / this.gridCellWidth));

            item.width = newWidth;
            item.height = newHeight;

            item.style = {
                'grid-column': `${item.screen_x} / span ${item.width}`,
                'grid-row': `${item.screen_y} / span ${item.height}`
            };

            this.changeDetectorRef.detectChanges();

            this.checkUpdates(item);
        };

        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }

    checkUpdates(item: WidgetModel): void {
        if (JSON.stringify(this.widgets) !== JSON.stringify(this.cloneWidgets)) {
            this.modifiedWidgets[item.id] = item;
            this.isModifiedWidgets = true;
        } else {
            this.modifiedWidgets = {};
            this.isModifiedWidgets = false;
        }
    }

    widgetsUpdate(action: 'Save' | 'Cancel') {
        action === 'Save' ? this.saveWidgetsUpdates() : this.cancelWidgetsUpdates()
    }

    saveWidgetsUpdates(): void {
        Object.values(this.modifiedWidgets).forEach((widget: WidgetModel) => {
            const requestData = {
                title: widget.title,
                width: widget.width,
                height: widget.height,
                screen_x: widget.screen_x,
                screen_y: widget.screen_y,
            };
            this.formState = 'Submitting'
            this.widgetsService.updateWidget(widget.id, requestData).subscribe({
                next: (data) => {
                    delete this.modifiedWidgets[widget.id];
                    if (Object.keys(this.modifiedWidgets).length === 0) {
                        this.isModifiedWidgets = false;
                        this.changeDetectorRef.detectChanges();
                        this.alertService.setAlert(data.message, 'green');
                    }
                    this.formState = 'Default'
                    this.changeDetectorRef.detectChanges()
                }, error: err => {
                    this.changeDetectorRef.detectChanges()
                    this.alertService.setAlert(err.message, 'blue');
                    this.formState = 'Default'
                }
            });
        });
    }

    cancelWidgetsUpdates(): void {
        this.widgets = structuredClone(this.cloneWidgets);
        this.isModifiedWidgets = false;
        this.modifiedWidgets = {};
    }

    deleteWidget(widgetId: number): void {
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_WIDGET'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then((data:any) => {
            if (data) {
                this.widgetsService.deleteWidget(widgetId).subscribe({
                    next: res => {
                        this.alertService.setAlert(res.message, 'green');
                        this.initializeWidgets();
                    }, error: err => {
                        this.alertService.setAlert(err.message, 'blue');
                    }
                });
            }
        });
    }

    openWidgetSettings(widget: WidgetModel): void {
        this.isSettingsLoading = true
        this.widgetsService.getWidgetSettings(widget).subscribe(widget => {
            let dialogRef = this.dialog.open(AppWidgetRootSettingsComponent, this.widgetsComponents.get(widget.widget_key + '_SETTINGS' as TWidgetKeys)?.dialogOptions || DEFAULT_SETTINGS_DIALOG)
            dialogRef.componentInstance.widgetSettingsComponent = this.widgetsComponents.get(widget.widget_key + '_SETTINGS' as TWidgetKeys)?.component
            dialogRef.componentInstance.widget = widget
            this.isSettingsLoading = false
        })
    }

    changePage(page: number, widget: WidgetModel): void {
        this.widgetsService.getWidgetById(widget.id, {current_page: page, limit: 15}).subscribe({
            next: resWidget => {
                let widget:any = this.widgets.find(x => x.id === widget.id)
                widget ? widget.content = structuredClone(resWidget.widget.content) : null;
                let clonedWidget = this.cloneWidgets.find(x => x.id === widget.id)
                clonedWidget ? clonedWidget.content = structuredClone(resWidget.widget.content) : null;
                this.changeDetectorRef.detectChanges();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
}
